import React from 'react'

import styles from "./styles.module.scss"
import { PlusOutlined } from '@ant-design/icons'

export default function AddNewItem({ text, onClick }) {
    return (
        <div onClick={onClick} className={styles.container}>
            <div className={styles.iconContainer}>
                <PlusOutlined className={styles.icon}/>
            </div>
            <div className={styles.text}>
                {text}
            </div>
        </div>
    )
}
